export default {
  getHead: () => {
    return [{name: '학교(기관)명'}, {name: '피평가자'}, {name: '평가일'}, {name: '소속명'}, {name: '부서명'}, {name: '작성자'}]
  },
  getCol: (index, value, func) => {
    try {
      switch (index) {
      case 0: return func.getContent(value).stdInfo.field_name
      case 1: return func.getContent(value).inputA_2
      case 2: return func.getContent(value).inputA_3
      case 3: return func.getContent(value).stdInfo.department // 소속명
      case 4: return func.getContent(value).stdInfo.com_name // 부서명
      case 5: return func.getContent(value).stdInfo.writer_name // 작성자
      }
    } catch (e) { /*ignore*/ }
    return ''
  },
  getSearchKeyValue: (nav) => {
    if (nav.value.inputA_3) {
      nav.dateTarget = 'content$body.inputA_3'
      nav.dateBegin = 'nav.value.inputA_3.sDate'
      nav.dateEnd = 'nav.value.inputA_3.eDate'
    }
    return { inputA_3: nav.value.inputA_3}
  },
  getSearchKeyword: (nav) => {
    const returnData = []

    switch (nav.value.searchType) {
    case '학교(기관)명': returnData.push('content$body.stdInfo.field_name*%[:default_skw]%'); break
    case '피평가자': returnData.push('content$body.inputA_1*%[:default_skw]%'); break
    case '소속명': returnData.push('content$body.stdInfo.department*%[:default_skw]%'); break
    case '부서명': returnData.push('content$body.stdInfo.com_name*%[:default_skw]%'); break
    case '작성자': returnData.push('content$body.stdInfo.writer_name*%[:default_skw]%'); break
    }

    return returnData
  },
}
